import React, { useEffect } from "react";
import styles from "./ButtonDropdown.module.css";
import { useHistory } from "react-router-dom";
import { useAuth } from "context/auth";
import { ReactComponent as ArrowDown } from "icons/arrow-down.svg";

type Props = {};

const ButtonDropdown: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const { userName, userRole, reloadContextData } = useAuth();

  useEffect(() => {
    if (!userName || !userRole) {
      reloadContextData();
    }
  }, [reloadContextData, userName, userRole]);

  return (
    <div className={styles.dropdown}>
      <div className="w-auto flex flex-col cursor-pointer mr-12">
        <div className="flex flex-row">
          <div
            className="flex flex-col font-nunito text-sm"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: "#000000",
            }}
          >
            {userName}
          </div>
          <div className="flex flex-col ml-2 mt-1">
            <ArrowDown />
          </div>
        </div>
        <div
          className="flex flex-row font-nunito text-xs"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#555555",
          }}
        >
          {userRole && userRole[0].toUpperCase() + userRole.substring(1)}
        </div>
      </div>
      <div className={styles["dropdown-content"]}>
        <span
          className="cursor-pointer"
          onClick={() => {
            history.push("/account-settings");
          }}
        >
          <div className="flex flex-row justify-center my-3">
            <div
              className="font-nunito text-sm"
              style={{
                fontStyle: "normal",
                fontWeight: 400,
                color: "#4D565C",
              }}
            >
              Account settings
            </div>
          </div>
        </span>
        <div className="border-b" />
        <span
          className="cursor-pointer"
          onClick={() => {
            localStorage.clear();
            history.push(`/login/${userRole}`);
            window.location.reload();
          }}
        >
          <div className="flex flex-row justify-center my-3">
            <div
              className="font-nunito text-sm"
              style={{
                fontStyle: "normal",
                fontWeight: 400,
                color: "#4D565C",
              }}
            >
              Logout
            </div>
          </div>
        </span>
      </div>
    </div>
  );
};

export default ButtonDropdown;
